module.exports = __webpack_public_path__ + "static/media/icon_extension_ppt.15adbfa6.svg";